import './index.scss'
import { Expandable } from "./../../js/Expandable";

class Assemby {
    constructor(el) {
        this.$el = el
    }
    
    init() {
        
        const remainingsItem = this.$el.querySelector('#remainings');
        if(remainingsItem) {
            new Expandable(remainingsItem);
        }
        
        const select = this.$el.querySelector(".download-select");
        const downloadCTA = this.$el.querySelector(".download-cta");

        select.addEventListener("change", function () {
            const selectedFile = this.value;
            const selectedOption = select.options[select.selectedIndex];
            const fileSize = selectedOption.getAttribute("data-filesize");
            
           if (selectedFile) {
                downloadCTA.href = selectedFile;
                downloadCTA.textContent = `${fileSize}`;
                downloadCTA.style.display = "inline-flex";
            } else {
                downloadCTA.style.display = "none";
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    [ ...document.querySelectorAll('.acf-assemby') ].forEach($block => {
        $block.expandygg = new Assemby($block)
    })
}, {capture: false, passive: true, once: true} || false)